import { useMemo } from "react";
import { useSpeakingParticipants } from "@livekit/components-react";
import type { Peer } from "@circle-react/types/Live/Peer";
import { usePaginatedSortedPeers } from "../usePaginatedSortedPeers";
import { useLivekitPeersList } from "./useLivekitPeersList";

const DEFAULT_SPEAKER_COUNT = 8;

export const useLivekitSpeakerRotation = (
  peers: Peer[],
  { pageSize = DEFAULT_SPEAKER_COUNT } = {},
) => {
  const { peersWithHandRaised } = useLivekitPeersList();
  const activeSpeakers = useSpeakingParticipants();
  const speakingIds = useMemo(
    () => activeSpeakers.map(({ identity }) => identity),
    [activeSpeakers],
  );
  const handRaisedIds = useMemo(
    () => peersWithHandRaised.map(({ id }) => id),
    [peersWithHandRaised],
  );
  const orderedPeers = usePaginatedSortedPeers({
    peers,
    speakingIds,
    handRaisedIds,
    pageSize,
  });

  return {
    orderedPeers,
  };
};
